import { createParser, system } from "@styled-system/core";
/**
 * The parser configuration for common outline properties
 */

var config = {
  outline: true,
  outlineOffset: true,
  outlineColor: {
    property: "outlineColor",
    scale: "colors"
  }
};
export var outline = system(config);
export var outlineParser = createParser(config);